module.exports = __webpack_public_path__ + "img/c6.edc46e6d.jpg";